import { render } from "./infoModal.vue?vue&type=template&id=2135d4e3&scoped=true"
import script from "./infoModal.vue?vue&type=script&lang=js"
export * from "./infoModal.vue?vue&type=script&lang=js"

import "./infoModal.vue?vue&type=style&index=0&id=2135d4e3&scoped=true&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2135d4e3"]])

export default __exports__